import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  menuSuperior: {
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  selectSetor: {
    width: '100%',
    marginBottom: '40px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  appBar: {
    marginTop: '15px',
  },
}))

export default useStyles
